import ShapePreview from "../MathTools/ShapePreview.js";

/* -------------------------------------------
   2) getQuestionPool() + generateQuizQuestion()
------------------------------------------- */
function getQuestionPool(topic) {
  if (topic === "rationalNumbers") {
    return [
      {
        question: () => {
          const n1 = Math.floor(Math.random() * 8) + 1;
          const d1 = Math.floor(Math.random() * 8) + 2;
          const n2 = Math.floor(Math.random() * 8) + 1;
          const d2 = Math.floor(Math.random() * 8) + 2;
          const sumN = n1 * d2 + n2 * d1;
          const sumD = d1 * d2;
          return {
            q: `Add: ${n1}/${d1} + ${n2}/${d2} = ? (unsimplified)`,
            a: `${sumN}/${sumD}`,
            distract: [
              `${sumN + d1}/${sumD}`,
              `${sumN}/${sumD + 1}`
            ]
          };
        }
      },
      {
        question: () => {
          const n1 = Math.floor(Math.random() * 5) + 1;
          const d1 = Math.floor(Math.random() * 5) + 2;
          const n2 = Math.floor(Math.random() * 5) + 1;
          const d2 = Math.floor(Math.random() * 5) + 2;
          const productN = n1 * n2;
          const productD = d1 * d2;
          return {
            q: `Multiply: ${n1}/${d1} × ${n2}/${d2} = ? (unsimplified)`,
            a: `${productN}/${productD}`,
            distract: [
              `${productN + 1}/${productD}`,
              `${productN}/${productD + 1}`
            ]
          };
        }
      },
      {
        question: () => {
          const n1 = -(Math.floor(Math.random() * 5) + 1);
          const d1 = Math.floor(Math.random() * 6) + 2;
          const n2 = Math.floor(Math.random() * 5) + 1;
          const d2 = Math.floor(Math.random() * 6) + 2;
          const sumN = n1 * d2 + n2 * d1;
          const sumD = d1 * d2;
          return {
            q: `Add: ${n1}/${d1} + ${n2}/${d2} = ?`,
            a: `${sumN}/${sumD}`,
            distract: [
              `${sumN + 2}/${sumD}`,
              `${sumN}/${sumD + 2}`
            ]
          };
        }
      },
      {
        question: () => {
          const numerator = Math.floor(Math.random() * 11) - 5;
          let denominator = Math.floor(Math.random() * 5) + 1;
          if (denominator === 0) denominator = 1;
          const val = (numerator / denominator).toFixed(2);
          return {
            q: `Convert the fraction ${numerator}/${denominator} to decimal (rounded 2 decimals).`,
            a: String(val),
            distract: [
              (parseFloat(val) + 0.1).toFixed(2),
              (parseFloat(val) - 0.1).toFixed(2)
            ]
          };
        }
      }
    ];
  } else if (topic === "equations") {
    return [
      {
        question: () => {
          const A = Math.floor(Math.random() * 3) + 2;
          const B = Math.floor(Math.random() * 6) - 3;
          const C = Math.floor(Math.random() * 5) - 2;
          const D = Math.floor(Math.random() * 6) - 3;
          const leftCoeff = A - 1;
          const right = D - (A * B + C);
          const sol = leftCoeff === 0 ? 0 : (right / leftCoeff).toFixed(1);
          return {
            q: `Solve: ${A}(x + ${B}) + ${C} = x + ${D}`,
            a: sol,
            distract: [
              (parseFloat(sol) + 1).toFixed(1),
              (parseFloat(sol) - 1).toFixed(1)
            ]
          };
        }
      },
      {
        question: () => {
          const offset = Math.floor(Math.random() * 6) - 3;
          const rightSide = Math.floor(Math.random() * 5) + 2;
          const sol = 2 * (rightSide - offset);
          return {
            q: `Solve: x/2 + ${offset} = ${rightSide}`,
            a: sol,
            distract: [sol + 1, sol - 1]
          };
        }
      },
      {
        question: () => {
          const xVal = Math.floor(Math.random() * 11) - 5;
          const lhs = 3 * xVal - 5;
          const K = lhs - 2 * xVal;
          return {
            q: `Solve: 3x - 5 = 2x + ${K}`,
            a: xVal,
            distract: [xVal + 2, xVal - 2]
          };
        }
      },
      {
        question: () => {
          const A = Math.floor(Math.random() * 4) + 1;
          const denom = Math.floor(Math.random() * 3) + 2;
          const offset = Math.floor(Math.random() * 5) - 2;
          const right = Math.floor(Math.random() * 6) - 3;
          const fraction = A / denom;
          const sol = (right - offset) / fraction;
          const ans = sol.toFixed(1);
          return {
            q: `Solve: (${A}/${denom})x + ${offset} = ${right}`,
            a: ans,
            distract: [
              (parseFloat(ans) + 1).toFixed(1),
              (parseFloat(ans) - 1).toFixed(1)
            ]
          };
        }
      }
    ];
  } else if (topic === "proportions") {
    return [
      {
        question: () => {
          const a = Math.floor(Math.random() * 8) + 2;
          const b = Math.floor(Math.random() * 8) + 2;
          const d = Math.floor(Math.random() * 8) + 2;
          const x = (a * d) / b;
          return {
            q: `Solve the proportion: ${a}/${b} = x/${d}`,
            a: x,
            distract: [x + 2, x - 1]
          };
        }
      },
      {
        question: () => {
          const scale = Math.floor(Math.random() * 30) + 10;
          const drawing = Math.floor(Math.random() * 6) + 1;
          const realLen = scale * drawing;
          return {
            q: `Scale 1:${scale}. If the drawing shows ${drawing} inches, what's the real length in inches?`,
            a: realLen,
            distract: [realLen + 5, realLen - 3]
          };
        }
      },
      {
        question: () => {
          const items = Math.floor(Math.random() * 10) + 2;
          const cost = (Math.random() * 20 + 5).toFixed(2);
          const per = (parseFloat(cost) / items).toFixed(2);
          return {
            q: `If ${items} items cost $${cost}, what's the cost per item (in $)?`,
            a: per,
            distract: [
              (parseFloat(per) + 0.5).toFixed(2),
              (parseFloat(per) - 0.5).toFixed(2)
            ]
          };
        }
      },
      {
        question: () => {
          const a = Math.floor(Math.random() * 5) + 1;
          const b = Math.floor(Math.random() * 5) + 1;
          return {
            q: `Convert ratio ${a}:${b} to a fraction (a/b form).`,
            a: `${a}/${b}`,
            distract: [`${b}/${a}`, `${a + b}/${b}`]
          };
        }
      }
    ];
  } else if (topic === "geometry") {
    return [
      {
        question: () => {
          const r = Math.floor(Math.random() * 6) + 2;
          const areaVal = (3.14 * r * r).toFixed(2);
          return {
            q: `Approx area of circle with radius=${r}? (π≈3.14)`,
            a: areaVal,
            distract: [
              (parseFloat(areaVal) + 5).toFixed(2),
              (parseFloat(areaVal) - 3).toFixed(2)
            ],
            visual: <ShapePreview shape={{ type: "circle", radius: r }} />
          };
        }
      },
      {
        question: () => {
          const l = Math.floor(Math.random() * 10) + 3;
          const w = Math.floor(Math.random() * 10) + 3;
          const perimeter = 2 * (l + w);
          return {
            q: `Perimeter of rectangle ${l}×${w}?`,
            a: perimeter,
            distract: [l + w, perimeter + 2],
            visual: <ShapePreview shape={{ type: "rectangle", length: l, width: w }} />
          };
        }
      },
      {
        question: () => {
          const l = Math.floor(Math.random() * 5) + 2;
          const w = Math.floor(Math.random() * 5) + 2;
          const h = Math.floor(Math.random() * 5) + 2;
          const vol = l * w * h;
          return {
            q: `Volume of prism ${l}×${w}×${h}?`,
            a: vol,
            distract: [vol + 5, l + w + h],
            visual: <ShapePreview shape={{ type: "prismPreview", l, w, h }} />
          };
        }
      },
      {
        question: () => {
          const a = Math.floor(Math.random() * 60) + 60;
          const b = Math.floor(Math.random() * 60) + 30;
          const c = 180 - (a + b);
          return {
            q: `In a triangle, two angles are ${a}° and ${b}°. Find the third angle.`,
            a: c,
            distract: [c + 10, Math.abs(c - 10)],
            visual: <ShapePreview shape={{ type: "triangleAngle", a, b, hideC: true }} />
          };
        }
      },
      {
        question: () => {
          const x = Math.floor(Math.random() * 11) - 5;
          let y = 0;
          while (y === 0) {
            y = Math.floor(Math.random() * 11) - 5;
          }
          const reflected = `(${x}, ${-y})`;
          const distract = [
            `(${x}, ${y})`,
            `(${-x}, ${y})`
          ];
          return {
            q: `Reflect the point (${x}, ${y}) across the x-axis. New coordinates?`,
            a: reflected,
            distract,
            visual: (
              <ShapePreview
                shape={{ type: "reflection", original: { x, y }, axis: "x" }}
              />
            )
          };
        }
      },
      {
        question: () => {
          let x = 0;
          while (x === 0) {
            x = Math.floor(Math.random() * 11) - 5;
          }
          const y = Math.floor(Math.random() * 11) - 5;
          const reflected = `(${-x}, ${y})`;
          const distract = [
            `(${x}, ${y})`,
            `(${x}, ${-y})`
          ];
          return {
            q: `Reflect the point (${x}, ${y}) across the y-axis. New coordinates?`,
            a: reflected,
            distract,
            visual: (
              <ShapePreview
                shape={{ type: "reflection", original: { x, y }, axis: "y" }}
              />
            )
          };
        }
      }
    ];
  } else if (topic === "probability") {
    return [
      {
        question: () => {
          const q = "Probability of flipping heads on a fair coin?";
          return { q, a: "1/2", distract: ["1/3", "1/4"] };
        }
      },
      {
        question: () => {
          const q = "Probability of rolling a 7 with two dice?";
          return { q, a: "1/6", distract: ["1/12", "1/3"] };
        }
      },
      {
        question: () => {
          const q = "Probability of flipping heads twice in a row (fair coin)?";
          return { q, a: "1/4", distract: ["1/2", "1/8"] };
        }
      },
      {
        question: () => {
          const reds = Math.floor(Math.random() * 5) + 1;
          const blues = Math.floor(Math.random() * 5) + 1;
          const total = reds + blues;
          const query = `A bag has ${reds} red and ${blues} blue marbles. Probability of picking red?`;
          const fraction = `${reds}/${total}`;
          return { q: query, a: fraction, distract: [`${blues}/${total}`, "1/2"] };
        }
      },
      {
        question: () => {
          const arr = [];
          for (let i = 0; i < 5; i++) {
            arr.push(Math.floor(Math.random() * 10) + 1);
          }
          const sum = arr.reduce((acc, v) => acc + v, 0);
          const mean = (sum / 5).toFixed(1);
          return {
            q: `Numbers: [${arr.join(", ")}]. Find the mean (1-decimal).`,
            a: mean,
            distract: [
              (parseFloat(mean) + 1).toFixed(1),
              (parseFloat(mean) - 1).toFixed(1)
            ]
          };
        }
      }
    ];
  } else {
    // summary/final fallback
    return [
      {
        question: () => ({
          q: "Quick check: 12 × 3 = ?",
          a: 36,
          distract: [33, 39]
        })
      },
      {
        question: () => ({
          q: "Approx area circle radius=5 (π≈3.14)?",
          a: (3.14 * 5 * 5).toFixed(2),
          distract: ["65.5", "90.5"]
        })
      },
      {
        question: () => ({
          q: "Solve: x/2 - 3 = 7",
          a: 20,
          distract: [10, 13]
        })
      },
      {
        question: () => ({
          q: "Probability of flipping 3 heads in a row?",
          a: "1/8",
          distract: ["1/4", "1/6"]
        })
      },
      {
        question: () => ({
          q: "Add: -2/3 + 1/6 = ? (unsimplified)",
          a: "-1/2",
          distract: ["-1/6", "-3/4"]
        })
      }
    ];
  }
}

export function generateQuizQuestion(forcedTopic) {
  const topics = forcedTopic
    ? [forcedTopic]
    : ["rationalNumbers","equations","proportions","geometry","probability","summary"];
  const topic = topics[Math.floor(Math.random() * topics.length)];
  const pool = getQuestionPool(topic);
  if (!pool || !pool.length) {
    return {
      question: "2 + 2=?",
      correctAnswer: 4,
      options: [4, 3, 5]
    };
  }
  const chosen = pool[Math.floor(Math.random() * pool.length)];
  const qObj = chosen.question();

  if (!qObj || !qObj.q || qObj.a === undefined) {
    const question = qObj.q;
    const correctAnswer = qObj.a;
    const distract = qObj.distract || [];
    return {
      question,
      correctAnswer,
      options: [correctAnswer, ...distract].sort(() => Math.random() - 0.5),
      visual: qObj.visual
    };
  }

  const distract = qObj.distract || [];
  const options = [qObj.a, ...distract].sort(() => Math.random() - 0.5);
  return {
    question: qObj.q,
    correctAnswer: qObj.a,
    options,
    visual: qObj.visual
  };
}